import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersonnalisationClient } from '../../services/Api/swagger';

export interface ReferentielState {
  personnalisation?: PersonnalisationClient;
}

const initialState: ReferentielState = {
  personnalisation: undefined,
};

export const ReferentielSlice = createSlice({
  name: '@@app/referentiel',
  initialState: initialState,
  reducers: {
    setPersonnalisationPart: (state: ReferentielState, action: PayloadAction<PersonnalisationClient>) => {
      state.personnalisation = action.payload;
    },
  },
});

export const {
  setPersonnalisationPart,
} = ReferentielSlice.actions;

// Selectors
export const getPersonnalisationPart = (state): PersonnalisationClient => state.referentiel.personnalisation && state.referentiel.personnalisation;
